import settings from '/@/core/settings';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const CatalogBenefits = (props) => {
    return (
        <div className={styles.root}>
            <Title theme={settings.app.theme}>
                <div className={styles.number}>{props.number}.</div>
            </Title>
            <div className={styles.text}>{props.message}</div>
        </div>
    );
};

export default CatalogBenefits;
